import { render } from "./Notes12.vue?vue&type=template&id=73ba277e&scoped=true"
import script from "./Notes12.vue?vue&type=script&lang=js"
export * from "./Notes12.vue?vue&type=script&lang=js"

import "./Notes12.vue?vue&type=style&index=0&id=73ba277e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ba277e"]])

export default __exports__